document.write("HELLO");



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/